module.exports = __webpack_public_path__ + "media/images/row1_img1-cd447c0b9af716fb4574a61e8424b257.jpg";